const BASE = 'https://base.api.k-hub.org/'
const BASE_IMAGE = 'https://base.api.k-hub.org'
const REPORT = 'https://report.api.k-hub.org/'
const KEY = 'JDCsOuUr.xomfRKR4t4fs3uedwhUvfyU3ZkUVJDWl'

export const GoogleMapApiScriptOptions = {
  googleMapsApiKey: 'AIzaSyDUzzFb6xuDVMK0zHYTqsqkIsESP0TG5v0',
  libraries: ['places'],
}

export const TINYMCE_API_KEY = "p92e8neygbpdv4yznm7pvlowzukov64286chr8rkq5td7s1z"
export const CORS_PREFIX = process.env.NODE_ENV === 'development' ? `https://cors-anywhere.herokuapp.com/` : ''

// Switcher between mock API and real API
const _switch = true

const api = {
  // General
  available: _switch,
  key: KEY,
  base: BASE,
  base_image: _switch ? BASE_IMAGE : '',
  report: REPORT,
  system_list: 'a1/system_list/kategori/',
  tag: 'a1/system_list/tag/',
  occupation: 'a1/system_list/pekerjaan/',
  gallery: `a1/galleries/`,
  city: 'a1/kotakab/?provinsi=',
  province: 'a1/provinsi/',

  // Auth & Account
  login: `a1/auth/`,
  account: 'a1/accounts/',
  account_create: 'a1/accounts/register/',
  otp: 'a1/accounts/otp/',
  otp_verification: 'a1/accounts/otp/verification/',
  otp_forgot_password: 'a1/accounts/otp/forgotpassword/',
  otp_event_confirmation: 'a1/accounts/otp/eventconfirmation/',
  forgot_password: 'a1/accounts/forgotpassword/',
  change_password: 'a1/accounts/editpassword/',
  account_verify: 'a1/accounts/emailverified/',

  // Individu
  individu: 'a1/individu/',
  individu_update: 'a1/individu/modify/',
  individu_tickets: 'a1/individu/eventparticipant/',
  individu_social_media: `a1/individu/sosialmedia/`,

  // Organization
  /**
   * Note
   * organization_programs: without '/' at the end.
   * organization_programs1: with '/' at the end.
   */
  organizations_available: true,
  organizations: `a1/organizations/`,
  organizations_update: `a1/organizations/modify/`,
  organization_milestone: `a1/organizations/milestoneorganisasi/`,
  organization_partner: `a1/organizations/partnerorganisasiinternal/`,
  organization_partner_external: `a1/organizations/partnerorganisasieksternal/`,
  organization_programs: `a1/organizations/programs`,
  organization_programs1: `a1/organizations/programs/`,
  organization_events: `a1/organizations/events`,
  organization_events1: `a1/organizations/events/`,
  organization_resources: `a1/organizations/resources`,
  organization_resources1: `a1/organizations/resources/`,
  organization_blogs: `a1/organizations/blogs`,
  organization_blogs1: `a1/organizations/blogs/`,
  organization_social_media: `a1/organizations/sosialmedia/`,
  organization_location: `a1/organizations/lokasiorganisasi/`,
  organization_visibility: `a1/organizations/visibilitydefault/`,

  // Member Management
  invitations: 'a1/organisasijoin/',
  invitations_respond: 'a1/organisasijoin/',
  join_requests: `a1/individujoin/`,
  join_requests_respond: `a1/individujoin/`,

  // Program
  programs_available: true,
  programs: `a1/programs/`,
  programs_gallery: `a1/programs/galleries/`,
  programs_file: `a1/programs/files/`,
  programs_journey: `a1/programs/journey/`,
  programs_milestone: `a1/programs/fase/`,
  programs_partner_internal: `a1/programs/partneractivityinternal/`,
  programs_partner_external: `a1/programs/partneractivityeksternal/`,
  programs_location: `a1/programs/lokasi/`,
  programs_statistic: `a1/programs/activityresult/`,
  programs_survey: `a1/programs/baselineendlinesurvey/`,
  programs_featured: `a1/featuredprogram/`,
  programs_testimoni: `a1/programs/testimonynonuser/`,
  testimoni_external: `a1/interactions/testimoninonuser/`,
  testimoni_internal: `a1/interactions/testimoniuser/`,

  // Blog
  blogs: `a1/blogs/`,
  blogs_gallery: `a1/blogs/galleries/`,
  blogs_featured: `a1/featuredblog/`,

  // Resource
  resources_available: true,
  resources: `a1/resources/`,
  resources_file: `a1/resources/files/`,
  resources_featured: `a1/featuredresource/`,

  // Event
  events: `a1/events/`,
  events_extension: `a1/events/activityorganizing/`,
  events_featured: `a1/featuredevent/`,
  events_gallery: `a1/events/galleries/`,
  events_location: `a1/events/lokasi/`,
  participant_internal: `a1/events/activityparticipantinternal/`,
  participant_external: `a1/events/activityparticipanteksternal/`,
  event_location_online: `a1/events/lokasionline/`,

  careers: `a1/daftarloker/`,
  career_slides: `a1/sliderloker/`,
  search: `a1/search/`,

  comment: `a1/interactions/comments/`
}

export default api
